<template>
  <div>
    <div class="overlay" @click="close()" />

    <div class="popup">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.history.pushState(null, null, location.href);
    window.addEventListener(
      "popstate",
      () => {
        this.close();
      },
      { once: true }
    );
  },

  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
  font-size: 170%;
  min-width: 30rem;
}

.popup {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: white;
  padding: 2rem;
  border-radius: 0.75rem;
  font-size: 170%;
  min-width: 30rem;
}
</style>
